import './index.css'

import noop from 'lodash/noop'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'

import configurationSetting from './api/httpClient'
import App from './App'
import { modifyArrayClass } from './helpers/utils'
import { i18nRefresh } from './i18n'
import reportWebVitals from './reportWebVitals'
import store from './store'

modifyArrayClass()
configurationSetting(store)
i18nRefresh()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(noop)
